import { makeAPIRequest } from '../../services/apiClient'
import { utmHotJob, utmTopJob } from '../../helpers/utmTracking'
import { ELanguage } from '@microfrontends/react-components'

export default async function dataSource(language, userId) {
	let data = []
	let apiUrl = `${
		process.env.FEATURED_JOBS_API_BASE
	}?hitsPerPage=72&t=${String(Date.now())}`
	if (userId) {
		apiUrl += `&userId=${userId}`
	}

	try {
		data = await makeAPIRequest(apiUrl, 'get', language)

		if (!!data) {
			return data.map((item) => {
				let utmQueryString = ''

				if (item.typeTopJob == 2) {
					utmQueryString = utmHotJob()
				} else if (item.typeTopJob == 0) {
					utmQueryString = utmTopJob()
				}
				return {
					title: item.jobTitle,
					cityNames: item.cityNames,
					cityNamesEN: item.cityNamesEN,
					company: item.companyName,
					companyId: item.companyId,
					logo: item.companyLogo,
					url:
						utmQueryString != ''
							? `${item.url}/?${utmQueryString}`
							: item.url,
					isHot: item.typeTopJob == 2,
					jobDescription: item.jobDescription,
					jobRequirement: item.jobRequirement,
					jobLevel:
						language === ELanguage.VI
							? item.jobLevelName
							: item.jobLevelNameEN,
					jobLevelId: item.jobLevelId,
					salary: item.prettySalary,
					address: item.address,
					jobId: item.id,
					alias: item.alias,
					isAnonymous: !!item.isAnonymous
				}
			})
		}
	} catch (err) {
		return []
	}
}
